import { PureComponent } from 'react';
import { logCallingError } from 'calling-error-reporting/report/error';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TimelineCallErrorBoundary extends PureComponent {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    logCallingError({
      errorMessage: 'Error in Inbox timeline item',
      extraData: {
        error,
        errorInfo
      }
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx(UIAlert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.error-boundary.title"
        }),
        type: "danger",
        use: "inline",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.error-boundary.text"
        })
      });
    }
    return this.props.children;
  }
}